import { BadgeCheck, Quote } from "lucide-react";
import Seo from "@/components/Seo";
import { PageHero } from "@/pages/About";
import { CtaBand } from "@/pages/Home";
import { Reveal } from "@/components/Reveal";
import { useLanguage } from "@/context/LanguageContext";
import { testimonials as fallbackTestimonials } from "@/data/testimonials";
import { useTestimonials } from "@/hooks/useTestimonials";

export default function Testimonials() {
  const { lang, t } = useLanguage();
  const { testimonials } = useTestimonials(fallbackTestimonials);
  return (
    <main data-testid="testimonials-page">
      <Seo
        title="Client Testimonials — Carlos Vindel Realty, Miami"
        siteName="Carlos Vindel Realty"
        description="Real stories from first-time buyers, sellers, and relocating families who worked with Carlos Vindel across South Florida."
      />
      <PageHero testid="testimonials-hero" overline={t.testimonialsPage.overline} title={t.testimonialsPage.title} subtitle={t.testimonialsPage.subtitle} />

      <section className="bg-cream py-20 sm:py-28">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((tst, i) => (
            <Reveal key={tst.id} delay={(i % 3) * 0.08}>
              <figure
                data-testid={`testimonial-card-${tst.id}`}
                className="h-full bg-white border border-sand/80 p-8 flex flex-col hover:shadow-[0_16px_48px_rgba(13,19,26,0.1)] hover:-translate-y-1 transition-all duration-500"
              >
                <Quote className="w-6 h-6 text-gold rotate-180 mb-5" />
                <blockquote className="flex-1 text-[#525D6B] leading-relaxed text-[15px]">“{tst.quote[lang]}”</blockquote>
                <figcaption className="mt-7 pt-5 border-t border-sand/70">
                  <p className="font-serif text-lg text-ink">{tst.name}</p>
                  <p className="mt-1 flex items-center gap-2 text-xs text-[#8C96A4]">
                    <BadgeCheck className="w-3.5 h-3.5 text-gold" /> {tst.context[lang]}
                  </p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </section>

      <CtaBand />
    </main>
  );
}
